/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$bullet-list-normal-font-weight: 400 !default;
$bullet-list-large-font-weight: 700 !default;
$bullet-list-normal-text-size: 18px !default;
$bullet-list-large-text-size-desktop-large: 26px !default;
$bullet-list-large-text-size-desktop: 24px !default;
$bullet-list-large-text-size-tablet: 24px !default;
$bullet-list-large-text-size-phone: 22px !default;
$bullet-list-text-shadow: 0px 1px 1px rgba(57, 57, 58, 0.2) !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: flex;
  position: relative;
  font-family: $font-family-base;
  text-align: left;
}

.#{$prefix}bullet-list-item-wrapper {
  display: flex;
  align-items: flex-start;

  &.#{$prefix}highlight {
    eon-ui-icon {
      color: v(highlight);
    }
  }

  &.#{$prefix}large {
    eon-ui-icon {
      margin-top: -5px !important;

      @include for-size(tablet-or-larger) {
        margin-top: -4px !important;
      }

      @include for-size(desktop-l-or-larger) {
        margin-top: -3px !important;
      }
    }

    .#{$prefix}bullet-list-item-title-wrapper {
      padding-left: 11px !important;

      @include for-size(tablet-or-larger) {
        line-height: 24px;
      }

      @include for-size(desktop-l-or-larger) {
        line-height: 26px;
      }
      @include for-size(phone) {
        line-height: 22px;
      }

      .#{$prefix}bullet-list-item-title {
        font-weight: $bullet-list-large-font-weight;
        display: block;

        &.#{$prefix}text-shadow {
          text-shadow: $bullet-list-text-shadow;
        }

        @include for-size(phone) {
          font-size: $bullet-list-large-text-size-phone;
        }
        @include for-size(tablet) {
          font-size: $bullet-list-large-text-size-tablet;
        }
        @include for-size(desktop) {
          font-size: $bullet-list-large-text-size-desktop;
        }
        @include for-size(desktop-l-or-larger) {
          font-size: $bullet-list-large-text-size-desktop-large;
        }

        &.#{$prefix}info-icon-display {
          display: flex;
          line-height: 100%;
        }

        &.#{$prefix}align-info-icon {
          justify-content: space-between;
        }
      }
    }
  }

  &:not(.#{$prefix}large) {
    font-weight: $bullet-list-normal-font-weight;
    font-size: $bullet-list-normal-text-size;

    span {
      line-height: 24px;
    }
  }
}

eon-ui-icon {
  margin: 0 !important;
  z-index: 5;
  flex-shrink: 0;
  justify-content: center;
  color: v(iconColor);
}

.#{$prefix}bullet-list-item-title-wrapper {
  margin: 0 !important;
  z-index: auto;
  padding-left: 8px !important;

  .#{$prefix}bullet-list-item-title {
    font-family: $font-family-base;
    line-height: 100%;
    margin: 0; // reset user agent style
    color: v(textColor);
    transition: color $transition-duration ease-in-out;
  }

  .#{$prefix}info-icon-display {
    display: flex;
    line-height: 1.3;
  }

  .#{$prefix}align-info-icon {
    justify-content: space-between;
  }
}

.#{$prefix}full-width {
  width: 100%;
}

.#{$prefix}bullet-list-info-icon {
  align-items: flex-start;
  margin: 0 16px;
}

.#{$prefix}remove-right-spacing {
  margin-right: 0;
}
